const firebaseConfig = {
  apiKey: "AIzaSyBFzDS-EuRnAOJFQya4Mn81SB1C2CvBbrU",
  authDomain: "adaptable-invoicing-system.firebaseapp.com",
  databaseURL: "https://adaptable-invoicing-system.firebaseio.com",
  projectId: "adaptable-invoicing-system",
  storageBucket: "adaptable-invoicing-system.appspot.com",
  messagingSenderId: "242216638837",
  appId: "1:242216638837:web:4546306b092528c12edb3c",
  measurementId: "G-SFYJEDZBMQ"
};

  export default firebaseConfig
